"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  components: {
    "report-table": require("./elements/Table.vue").default
  },

  props: ["item"],

  data: function data() {
    return {
      tableHeader: ["Question", "", "Options", "Number of Questionnaires Completed", "Number of answers", "% of answers from completed", "Number of Yes answers", "% Answered Yes of those completed"]
    };
  },


  methods: {
    getDataForTable: function getDataForTable(data) {
      var arrayOfData = [];

      for (var itemId in data) {
        if (data.hasOwnProperty(itemId)) {
          var item = data[itemId];

          arrayOfData.push([item.name, item.groupName, item.option, item.attempts, item.added, this.getPercentage(item.added, item.attempts), item.answeredYes, this.getPercentage(item.answeredYes, item.attempts)]);
        }
      }
      return arrayOfData;
    },
    getPercentage: function getPercentage(of_number, from_number) {
      var result = of_number * 100 / from_number;

      if (isNaN(result) || !isFinite(result)) {
        result = 0;
      }

      return result.toFixed(2);
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/reports/tables/ComparePercentTable.vue
// module id = nawy
// module chunks = 0 1